import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "saveBar", "changes"]

  filter(event) {
    event.target.form.requestSubmit()
  }

  open(event) {
    if (event.target.closest("a, button")) return

    this.toggle(event)
  }

  toggle({ params: { id } }) {
    const editor = this.find("editor", id)
    const row = this.find("row", id)
    editor.hidden = !editor.hidden

    row.classList.toggle("admin-securities__row--open", !editor.hidden)
    row.querySelector("[aria-expanded]").setAttribute("aria-expanded", String(!editor.hidden))
  }

  async test({ params: { id, url } }) {
    const editor = this.find("editor", id)
    const response = this.find("response", id)
    const count = this.find("count", id)
    const query = new URLSearchParams({
      source: editor.querySelector("select").value,
      symbol: editor.querySelector("input[type=text]").value
    })

    response.textContent = "Loading…"
    count.hidden = true

    try {
      const result = await fetch(`${url}?${query}`, { headers: { Accept: "application/json" } })
      const data = await result.json()
      response.textContent = JSON.stringify(data.prices ?? data, null, 2)

      this.setCount(count, result.ok ? `${data.count} prices · ${Number(data.price).toFixed(2)} ${data.currency ?? ""}` : data.error, result.ok)
    } catch (error) {
      response.textContent = error.message
      this.setCount(count, error.message, false)
    }
  }

  track() {
    const dirtyRows = new Set()

    this.fields(this.formTarget).forEach((field) => {
      const dirty = this.isDirty(field)
      field.classList.toggle("admin-securities__input--dirty", dirty)
      if (dirty) dirtyRows.add(field.closest("tr"))
    })

    this.saveBarTarget.hidden = dirtyRows.size === 0
    this.changesTarget.textContent = dirtyRows.size === 1 ? "1 unsaved change" : `${dirtyRows.size} unsaved changes`

    return dirtyRows
  }

  discard() {
    this.formTarget.reset()
    this.track()
  }

  submit() {
    const dirtyRows = this.track()

    this.formTarget.querySelectorAll(".admin-securities__editor").forEach((row) => {
      if (dirtyRows.has(row)) return

      this.fields(row).forEach((field) => { field.disabled = true })
    })
  }

  fields(element) {
    return element.querySelectorAll("[name^='securities[']")
  }

  isDirty(field) {
    if (field.tagName !== "SELECT") return field.value !== field.defaultValue

    const initial = [...field.options].find((option) => option.defaultSelected) ?? field.options[0]
    return field.value !== initial?.value
  }

  setCount(count, text, ok) {
    count.textContent = text
    count.classList.toggle("admin-securities__badge--error", !ok)
    count.hidden = false
  }

  find(name, id) {
    return document.getElementById(`${name}_security_${id}`)
  }
}
